const url = new URL(window.location.href);
const queryParams = new URLSearchParams(url.search);

const highlightActiveElement =
  queryParams.has('highlightActiveElement') &&
  queryParams.get('highlightActiveElement') === '1';

if (window.parent === window && highlightActiveElement) {
  const ACTIVE_ELEMENT_MARKER = document.createElement('div');
  ACTIVE_ELEMENT_MARKER.style.position = 'fixed';
  ACTIVE_ELEMENT_MARKER.style.borderRadius = '1px';
  ACTIVE_ELEMENT_MARKER.style.boxShadow = `
  0 0 0 2px #00D9D3, 0 0 0 3px #fff,  0 0 0 5px #00D9D3
  `;

  document.body.appendChild(ACTIVE_ELEMENT_MARKER);

  let currentActiveElement;

  setInterval(() => {
    const { activeElement } = document as any;

    if (!activeElement) {
      return;
    }

    const { top, left, width, height } = activeElement.getBoundingClientRect();

    const currentActiveElementIsSection =
      activeElement.tagName.toLowerCase() === 'section';

    const topOffset = !currentActiveElementIsSection ? 5 : -20;
    const leftOffset = !currentActiveElementIsSection ? 5 : -20;
    const widthOffset = !currentActiveElementIsSection ? 10 : -40;
    const heightOffset = !currentActiveElementIsSection ? 10 : -40;

    ACTIVE_ELEMENT_MARKER.style.pointerEvents = 'none';
    ACTIVE_ELEMENT_MARKER.style.top = `${top - topOffset}px`;
    ACTIVE_ELEMENT_MARKER.style.left = `${left - leftOffset}px`;
    ACTIVE_ELEMENT_MARKER.style.width = `${width + widthOffset}px`;
    ACTIVE_ELEMENT_MARKER.style.height = `${height + heightOffset}px`;
    ACTIVE_ELEMENT_MARKER.style.zIndex = '2147483647';

    if (currentActiveElement !== activeElement) {
      // so only fires when activeElement changes
      // we can put the above code in here. but creates lag drawing the focus indication
      //

      currentActiveElement = activeElement;

      if (currentActiveElement.tagName.toLowerCase() === 'section') {
        console.log('is section :', currentActiveElement.tagName.toLowerCase());
      }
    }
  }, 1000 / 60);
}
